/**
 * Formata o valor de um input monetário e atualiza o estado do pagamento.
 *
 * Esta função é acionada no evento onChange de um input que espera um valor monetário.
 * Ela remove caracteres não numéricos, elimina zeros à esquerda, garante um valor mínimo
 * e formata o número para incluir uma vírgula e pontos como separadores de milhar.
 * Por fim, atualiza o estado do pagamento usando a função setSelectedPayment.
 *
 * @param {Event} event - Evento disparado pelo input.
 * @param {Function} setSelectedPayment - Função para atualizar o estado do pagamento.
 */
export function moneyInputChange(event, setSelectedPayment) {
    const { name, value } = event.target;

    const newValue = value
        .replace(/\D/g, "") // Remove tudo que não for número
        .replace(/^0+/, "") // Remove os zeros iniciais
        .padStart(3, "0") // Adiciona zeros à esquerda, caso necessário
        .replace(/(\d{1,})(\d{2})$/, "$1,$2") // Adiciona a vírgula decimal
        .replace(/(?=(\d{3})+(\D))\B/g, "."); // Adiciona o ponto como separador de milhares

    setSelectedPayment((prevState) => ({
        ...prevState,
        [name]: `R$ ${newValue}`,
    }));
}